import React, { useState, useEffect } from 'react';
import Footerdiv from "../layout/footer.js";
import Headerdiv from "../layout/header.js";
import {
  Layout, Space, Breadcrumb, Spin, theme
} from 'antd';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../appsettings.js';
import { AlertError } from '../usableclasses.js';
import { Page, Text, View, Document, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import printlogo from '../printpropertise/printlogoceylonika.png';

const { Content } = Layout;

const StockTransferPrint = () => {
  const { transferId } = useParams();
  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");

  const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

  const [stockTransfer, setStockTransfer] = useState(null);
  const [transferItems, setTransferItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLoading, setItemsLoading] = useState(true);

  // Format date helper function
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (e) {
      return dateString;
    }
  };
  const styles = StyleSheet.create({
    page: {
      padding: 20,
      fontSize: 10,
      fontFamily: 'Helvetica',

    },
    row: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10 },
    logo: { width: 150, height: 50 },
    companyInfo: { marginLeft: 10 },
    sectionBox: {
      // border: '1 solid #000',
      borderRadius: 5,
      marginBottom: 5,
      width: '48%',
      backgroundColor: '#edfcfc',
    },
    sectionBoxHeader: {
      borderRadius: 5,
      padding: 10,
      backgroundColor: '#a0fae8',
    },
    sectionBoxContent: {
      padding: 10,
    },
    table: {
      border: '1 solid #a0fae8',
      marginVertical: 10,
    },
    tableHeader: {
      padding: 5,
      flexDirection: 'row',
      borderBottom: '1 solid ',
      backgroundColor: '#a0fae8',
      fontWeight: 'bold',
    },
    tableRow: {
      padding: 5,
      flexDirection: 'row',
      borderBottom: '1 solid white',
      backgroundColor: '#edfcfc',
    },
    cell: { flex: 1, padding: 3 },
    centeredCell: { flex: 1, padding: 2, textAlign: 'center' },
    leftCell: { flex: 1, padding: 2, textAlign: 'left', width: "20%" },
    rightCell: { flex: 1, padding: 2, textAlign: 'right' },
    noteTaxRow: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 10 },
    signatureSection: { marginTop: 30, flexDirection: 'row', justifyContent: 'space-between' },
    footer: {
      position: 'absolute', margin: '0 10', bottom: 10, left: 0, right: 0, textAlign: 'center', fontSize: 9, borderTop: '1 solid #c3c3c3', padding: 5, // eslint-disable-line no-dupe-keys
    },
    // Style for the summary row within the table
    tableSummaryRow: {
      padding: 5, flexDirection: 'row', borderTop: '1 solid #a0fae8', backgroundColor: '#edfcfc',
    },
  });
  useEffect(() => {
    const loadStockTransferData = async () => {
      if (!transferId) {
        AlertError("Stock Transfer ID is missing.");
        setLoading(false);
        setItemsLoading(false);
        setStockTransfer(null);
        return;
      }

      setLoading(true);
      setItemsLoading(true);

      try {
        // Fetch header details
        const headerResponse = await axios.get(`${ApiURL}/stocktransfer/transferheaderdetails/${transferId}`, {
          headers: { SystemAccessToken: TOKEN }
        });

        if (headerResponse.data) {
          setStockTransfer(headerResponse.data);
        } else {
          AlertError('Failed to load stock transfer header data: No data received.');
          setStockTransfer(null);
        }
      } catch (error) {
        AlertError('Error loading stock transfer header details.');
        console.error('Error loading stock transfer header details:', error);
        setStockTransfer(null);
      } finally {
        setLoading(false);
      }

      try {
        // Fetch item details
        const itemsResponse = await axios.get(`${ApiURL}/stocktransfer/transferitemsdetails/${transferId}`, {
          headers: { SystemAccessToken: TOKEN }
        });

        if (itemsResponse.data) {
          setTransferItems(Array.isArray(itemsResponse.data) ? itemsResponse.data : []);
        } else {
          AlertError('Failed to load stock transfer items: No data received.');
        }
      } catch (error) {
        AlertError('Error loading stock transfer items.');
        console.error('Error loading stock transfer items:', error);
      } finally {
        setItemsLoading(false);
      }
    };

    loadStockTransferData();
  }, [transferId, ApiURL, TOKEN]);

  // Calculate total quantity
  const totalQuantity = transferItems.reduce((sum, item) => {
    const qty = parseFloat(item.transferQty);
    return sum + (isNaN(qty) ? 0 : qty);
  }, 0);

  return (
    <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
      <Headerdiv />
      <Content style={{ padding: '10px' }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item><Link to={"/stocks/transfer"}>Stock Transfer</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Print</Breadcrumb.Item>
          <Breadcrumb.Item>{transferId}</Breadcrumb.Item>
        </Breadcrumb>



        <div style={{ padding: 20, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG }}>
          <Space direction="vertical" style={{ width: "100%", padding: "15px" }}>

            {loading ? (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spin size="large" />
                <div style={{ marginTop: 16 }}>Loading stock transfer details...</div>
              </div>
            ) : stockTransfer ? (
              <>
                <PDFViewer width={"100%"} height={"500px"}>
                  <Document title={`ST-${stockTransfer.transReferance}`} subject={`ST-${stockTransfer.transReferance}`}>
                    <Page size="A4" style={styles.page} wrap>

                      <View style={styles.row}>
                        <View style={{ flexDirection: 'column', flex: 1 }}>
                          <Image src={printlogo} style={styles.logo} />
                          <View style={styles.companyInfo}>
                            <Text>Ceylonika Cosmetics (Pvt) Ltd</Text>
                            <Text>154/11, Pushparama Road, Kadawatha</Text>
                            <Text>www.ceylonikacosmetics.com | info@ceylonikacosmetics.com</Text>
                            <Text>+94 112 92 44 20</Text>
                          </View>
                        </View>

                        <View style={{ textAlign: 'right' }}>
                          <Text style={{ fontSize: 16, fontWeight: 'bold', paddingBottom: 5 }}>STOCK TRANSFER</Text>
                          <Text>Transfer Reference : {stockTransfer.transReferance || '#xxxxxxx'}</Text>
                          <Text>Date : {formatDate(stockTransfer.createdDate) || '__/__/20__'}</Text>
                          <Text>Created By : {stockTransfer.createdUsername || '--'}</Text>
                          <Text>Status : {stockTransfer.currentStatus || '--'}</Text>
                        </View>
                      </View>


                      <View style={styles.row}>
                        <View style={styles.sectionBox}>
                          <View style={styles.sectionBoxHeader}>
                            <Text style={{ fontWeight: 'bold' }}>From Stock</Text>
                          </View>
                          <View style={styles.sectionBoxContent}>
                            <Text>{stockTransfer.fromStockName || ''}</Text>
                          </View>

                        </View>

                        <View style={styles.sectionBox}>
                          <View style={styles.sectionBoxHeader}>
                            <Text style={{ fontWeight: 'bold' }}>To Stock</Text>
                          </View>
                          <View style={styles.sectionBoxContent}>
                            <Text>{stockTransfer.toStockName || ''}</Text>
                          </View>


                        </View>
                      </View>


                      <View style={styles.table}>
                        <View style={styles.tableHeader}>
                          <Text style={styles.leftCell} width={"20%"}>Code</Text>
                          <Text style={styles.leftCell} width={"50%"}>Item</Text>
                          <Text style={styles.leftCell} width={"15%"}>Size</Text>
                          <Text style={styles.rightCell} width={"10%"}>Qty</Text>

                        </View>
                        {transferItems.map((item, index) => (
                          <View style={styles.tableRow} key={index}>
                            <Text style={styles.leftCell}>{item.productSku}</Text>
                            <Text wrap={false} style={styles.leftCell}>{item.productName}</Text>
                            <Text style={styles.leftCell}>{item.productSize}{item.productUOM}</Text>
                            <Text style={styles.rightCell}>{item.transferQty}</Text>
                          </View>
                        ))}
                        {/* Summary Row within the table */}
                        <View style={styles.tableSummaryRow}>
                          {/* Spanning Code, Item, and Size columns. Text aligned to the right of this combined cell. */}
                          <Text style={{ ...styles.rightCell, width: "85%", fontWeight: 'bold', paddingRight: 5 }}>Total Qty :</Text>
                          {/* Qty column */}
                          <Text style={{ ...styles.rightCell, width: "10%", fontWeight: 'bold' }}>{totalQuantity}</Text>
                        </View>
                      </View>

                      <View style={styles.signatureSection}>
                        <Text>Date: .........../............../..............</Text>
                        <Text>Signature: __________________</Text>
                      </View>
                      <View style={{ marginTop: 5, flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <Text>Prepared By: {stockTransfer.createdUsername || 'N/A'}</Text> {/* eslint-disable-line no-mixed-spaces-and-tabs */}
                      </View>
                    </Page>
                  </Document>
                </PDFViewer>

              </>
            ) : (
              <div style={{ textAlign: 'center', padding: '50px' }}> {/* Handle case when stock transfer is not found */}
                <p>Stock transfer not found or failed to load.</p>
              </div>
            )}

          </Space>
        </div>
      </Content>
      <Footerdiv />
    </Layout>
  );
};

export default StockTransferPrint;
